import { Provider } from "@angular/core";
import { provideTanStackQuery, QueryClient } from "@tanstack/angular-query-experimental";

export const typesystemClientProviders: Provider[] = [provideTanStackQuery(new QueryClient())];
